import Modal from "react-bootstrap/Modal";
import BulkDeleteShifts from "../components/BulkDeleteShifts";

const BulkDeleteModal = ({ visible, close, shifts, isArchive = false }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          Bulk Delete Shifts
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>Are you sure you want to delete these shifts?</div>
          <BulkDeleteShifts
            shifts={shifts}
            onComplete={() => {
              close();
            }}
            close={close}
            isArchive={isArchive}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BulkDeleteModal;
